import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Zhongqianrenshu = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 64 64"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <filter
              height="26.667"
              width="26.667"
              y="0"
              x="0"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda34__b"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feBlend
                result="shape"
                in2="BackgroundImageFix"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.9960784316062927 0 0 0 0 0.7843137383460999 0 0 0 0 1 0 0 0 1 0" />
              <feBlend
                result="effect1_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="17.335"
              width="19.337"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda34__d"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.5647059082984924 0 0 0 0 0.07058823853731155 0 0 0 0 0.9450980424880981 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.40392157435417175 0 0 0 0 0.03921568766236305 0 0 0 0 0.5372549295425415 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="10.67"
              width="24.003"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda34__e"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.5647059082984924 0 0 0 0 0.07058823853731155 0 0 0 0 0.9450980424880981 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.40392157435417175 0 0 0 0 0.03921568766236305 0 0 0 0 0.5372549295425415 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <filter
              height="10.67"
              width="16.003"
              y="-3"
              x="-4"
              colorInterpolationFilters="sRGB"
              filterUnits="objectBoundingBox"
              id="cda34__f"
            >
              <feFlood
                result="BackgroundImageFix"
                floodOpacity="0"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                in="SourceAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix values="0 0 0 0 0.5647059082984924 0 0 0 0 0.07058823853731155 0 0 0 0 0.9450980424880981 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect1_dropShadow"
                in2="BackgroundImageFix"
              />
              <feBlend
                result="shape"
                in2="effect1_dropShadow"
                in="SourceGraphic"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
                in="SourceAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation=".75" />
              <feComposite
                k3="1"
                k2="-1"
                operator="arithmetic"
                in2="hardAlpha"
              />
              <feColorMatrix values="0 0 0 0 0.40392157435417175 0 0 0 0 0.03921568766236305 0 0 0 0 0.5372549295425415 0 0 0 0.5600000023841858 0" />
              <feBlend
                result="effect2_innerShadow"
                in2="shape"
              />
            </filter>
            <linearGradient
              id="cda34__c"
              y2=".873"
              x2=".826"
              y1=".093"
              x1=".137"
            >
              <stop
                stopColor="#D987F7"
                offset="0%"
              />
              <stop
                stopColor="#A65DF5"
                offset="100%"
              />
            </linearGradient>
            <clipPath id="cda34__a">
              <rect
                rx="31"
                height="64"
                width="64"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#cda34__a)">
            <circle
              fill="#F0F5F5"
              cy="32"
              cx="32"
              r="32"
            />
            <g filter="url(#cda34__b)">
              <path
                fill="url(#cda34__c)"
                fillRule="evenodd"
                d="M45.667 22.333v20q0 1.381-.977 2.357-.976.977-2.357.977h-20q-1.38 0-2.357-.977Q19 43.714 19 42.333v-20q0-1.38.976-2.357.977-.976 2.357-.976h20q1.381 0 2.357.976.977.977.977 2.357Z"
              />
            </g>
            <g filter="url(#cda34__d)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M38.5 32.885a1.335 1.335 0 1 0-2.083-1.666l-4.458 5.574L29.719 35a1.335 1.335 0 1 0-1.666 2.082l3.28 2.625a1.333 1.333 0 0 0 1.875-.208l5.292-6.615Z"
              />
            </g>
            <g filter="url(#cda34__e)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M24.234 26.667a1.336 1.336 0 1 1 0-2.667h13.2a1.335 1.335 0 1 1 0 2.667h-13.2Z"
              />
            </g>
            <g filter="url(#cda34__f)">
              <path
                fill="#FFF"
                fillRule="evenodd"
                d="M24.234 32a1.336 1.336 0 1 1 0-2.667h5.2a1.335 1.335 0 1 1 0 2.667h-5.2Z"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
)
